import React from 'react';

type Props = {
  subAppPath: string
};

class SubAppRedirect extends React.Component<Props> {
  private redirect () {
    const prevLoc: string = window.location.href;

    const sepIndex: number = prevLoc.indexOf('/#');

    const newLoc: string = prevLoc.substring(0, sepIndex) + this.props.subAppPath + prevLoc.substring(sepIndex);

    window.location.href = newLoc;
  }

  override componentDidMount (): void {
    this.redirect();
  }

  override componentDidUpdate (): void {
    this.redirect();
  }

  override render (): React.ReactNode {
    return null;
  }
}

export default SubAppRedirect;
